import { render, staticRenderFns } from "./TaxRRPayoffList.vue?vue&type=template&id=db92fe20&scoped=true"
import script from "./TaxRRPayoffList.vue?vue&type=script&lang=js"
export * from "./TaxRRPayoffList.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "db92fe20",
  null
  
)

export default component.exports